/** Uppercase display for long dropdown option labels (matches SIMA admin styling). */
export function toDropdownLabel(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return ''
  }
  return String(value).toUpperCase()
}
